import { Flex } from '@shared/components';
import { useLocation } from 'react-router-dom';

import { SideBar } from '../SideBar';

const HIDDEN_SIDE_BAR_PATHS = ['/login', '/forgot-password', '/setup-password'];

function Frame({ children }: { children?: React.ReactNode }) {
  const location = useLocation();

  const isHiddenSideBar = HIDDEN_SIDE_BAR_PATHS.includes(location.pathname);

  return (
    // TODO: parse Flex component as main but display flex still be block
    <Flex as='main' sx={{ width: 1, height: '100vh', display: 'flex' }}>
      {!isHiddenSideBar ? <SideBar /> : null}
      <Flex
        sx={{
          width: 1,
          minWidth: 0,
          overflow: 'auto',
          flexDirection: 'column',
          position: 'relative',
        }}
        id='frame-content'
      >
        {children}
      </Flex>
    </Flex>
  );
}

export default Frame;
